export default __webpack_public_path__ + "static/media/greenArrowDownLow.fec93c17.svg";